import React, { forwardRef } from 'react';
import { NotificationsUiModuleBody } from '../../../../../API';
import { UIModuleTypeForm } from '../../UIModuleForm';
import { useFormContext } from 'react-hook-form';
import { FormBody } from '../../styles';
import { LokaliseField } from '../../../../shared/LokaliseFields';
import { notificationsFormTestIds } from '../../../../shared/TestsIds';

const NotificationsForm = forwardRef<UIModuleTypeForm<NotificationsUiModuleBody>>(() => {
  const { control } = useFormContext<NotificationsUiModuleBody>();

  return (
    <FormBody data-testid={notificationsFormTestIds.formBody}>
      <div>
        <LokaliseField
          name="header"
          control={control}
          toTranslate="layouts.notifications.fields"
          dataTestId={notificationsFormTestIds.formField('header')}
          required
        />
      </div>
      <div>
        <LokaliseField
          name="subheader"
          control={control}
          toTranslate="layouts.notifications.fields"
          dataTestId={notificationsFormTestIds.formField('subheader')}
        />
      </div>
      <div>
        <LokaliseField
          name="text_body"
          control={control}
          toTranslate="layouts.notifications.fields"
          dataTestId={notificationsFormTestIds.formField('text_body')}
        />
      </div>
      <div>
        <LokaliseField
          name="primary_cta"
          control={control}
          toTranslate="layouts.notifications.fields"
          dataTestId={notificationsFormTestIds.formField('primary_cta')}
        />
      </div>
      <div>
        <LokaliseField
          name="secondary_cta"
          control={control}
          toTranslate="layouts.notifications.fields"
          dataTestId={notificationsFormTestIds.formField('secondary_cta')}
        />
      </div>
    </FormBody>
  );
});

NotificationsForm.displayName = 'NotificationsForm';

export default NotificationsForm;
